import { ComparisonTableDataType } from "@/schema/quote-page/page.schema";
import { PolicyPackagePrice } from "@/types/PolicyPackagePriceType";

const getComparisonTableData = (
  data: Record<string, ComparisonTableDataType>,
  isCruise?: boolean,
  tripType?: string,
  priceResult?: PolicyPackagePrice[]
) => {
  const dataNodes = data as unknown as Record<string, ComparisonTableDataType>;

  // Get list of declined cover packages for the current trip type
  const declinedCovers = new Set(
    priceResult
      ?.filter(
        (price) =>
          price.policyType === tripType && price.hasMedicalDeclined === true
      )
      .map((price) => price.policyPackage?.toLowerCase())
  );
  return Object.keys(dataNodes)
    .map((node) => {
      let testData;
      if (
        isCruise === dataNodes[node].isCruise &&
        tripType === dataNodes[node].tripType
      ) {
        // Filter out columns for declined covers
        const columnKeys = Object.keys(dataNodes[node].columnTitle || {});

        const filteredColumnTitle = columnKeys
          .filter((key) => {
            const columnData = dataNodes[node].columnTitle[key];
            const coverType = columnData?.title?.toLowerCase();
            const shouldKeep = !declinedCovers.has(coverType);

            return shouldKeep;
          })
          .reduce(
            (obj, key) => {
              obj[key] = dataNodes[node].columnTitle[key];
              return obj;
            },
            {} as Record<string, any>
          );

        // Filter out rows for declined covers (comparisonTableRow is a Record, not array)
        const filteredRows = Object.keys(
          dataNodes[node].comparisonTableRow || {}
        ).reduce(
          (obj, rowKey) => {
            const row = dataNodes[node].comparisonTableRow[rowKey];

            // Filter out declined covers from comparisonTableCell
            const filteredCells = Object.keys(row.comparisonTableCell || {})
              .filter((key) => {
                const cellData = row.comparisonTableCell[key];
                const coverType = cellData?.coverType?.toLowerCase();
                return !declinedCovers.has(coverType);
              })
              .reduce(
                (cellObj, key) => {
                  cellObj[key] = row.comparisonTableCell[key];
                  return cellObj;
                },
                {} as Record<string, any>
              );

            obj[rowKey] = {
              ...row,
              comparisonTableCell: filteredCells,
            };
            return obj;
          },
          {} as Record<string, any>
        );

        testData = {
          columnTitle: filteredColumnTitle,
          comparisonTableRow: filteredRows,
        };
      }
      return testData;
    })
    .filter(Boolean);
};

export default getComparisonTableData;
